// import svg icons
import 'base/icons/svg/soccer.svg'
import 'base/icons/svg/basketball.svg'
import 'base/icons/svg/tennis.svg'
import 'base/icons/svg/rugby.svg'
import 'base/icons/svg/cricket.svg'
import 'base/icons/svg/volleyball.svg'
import 'base/icons/svg/iceHockey.svg'
import 'base/icons/svg/darts.svg'
import 'base/icons/svg/Heartstone.svg'
import 'base/icons/svg/Overwatch.svg'
import 'base/icons/svg/StarCraft.svg'
import 'base/icons/svg/RocketLeague.svg'
import 'base/icons/svg/RainBowsix.svg'
import 'base/icons/svg/TableTennis.svg'
import 'base/icons/svg/CounterStrike.svg'
import 'base/icons/svg/DOTA.svg'
import 'base/icons/svg/NBAK.svg'
import 'base/icons/svg/Boxing.svg'
import 'base/icons/svg/Callofduty.svg'
import 'base/icons/svg/Futsal.svg'
import 'base/icons/svg/LeagueOfLegends.svg'
import 'base/icons/svg/AussieRules.svg'
import 'base/icons/svg/Snooker.svg'
import 'base/icons/svg/virtual.svg'
import 'base/icons/svg/baseball.svg'
import 'base/icons/svg/Badminton.svg'
import 'base/icons/svg/Handball.svg'
import 'base/icons/svg/e-iceHockey.svg'
import 'base/icons/svg/e-basketball.svg'
import 'base/icons/svg/AmericanFootball.svg'
import 'base/icons/svg/vsoccer.svg'
import defaultImageSrc from 'wap/common/images/default-nav-icon.png'
import eCricket from 'base/icons/png/e-cricket.png'
import eCricketAct from 'base/icons/png/e-cricket-act.png'
import eTennis from 'base/icons/png/e-tennis.png'
import eTennisAct from 'base/icons/png/e-tennis-act.png'
import eVolleyball from 'base/icons/png/e-volleyball.png'
import eVolleyballAct from 'base/icons/png/e-volleyball-act.png'

// sportId - iconfont 对象
export const sportIcon = {
  'sr:sport:1': 'icon-soccer',
  'sr:sport:2': 'icon-basketball',
  'sr:sport:3': 'icon-baseball',
  'sr:sport:5': 'icon-tennis',
  'sr:sport:12': 'icon-rugby',
  'sr:sport:21': 'icon-cricket',
  'sr:sport:23': 'icon-volleyball',
  'sr:sport:4': 'icon-iceHockey',
  'sr:sport:22': 'icon-darts',
  'sr:sport:113': 'icon-Heartstone',
  'sr:sport:121': 'icon-Overwatch',
  'sr:sport:112': 'icon-StarCraft',
  'sr:sport:128': 'icon-RocketLeague',
  'sr:sport:125': 'icon-RainBowsix',
  'sr:sport:20': 'icon-TableTennis',
  'sr:sport:109': 'icon-CounterStrike',
  'sr:sport:111': 'icon-DOTA',
  'sr:sport:10': 'icon-Boxing',
  'sr:sport:118': 'icon-Callofduty',
  'sr:sport:29': 'icon-Futsal',
  'sr:sport:110': 'icon-LeagueOfLegends',
  'sr:sport:13': 'icon-AussieRules',
  'sr:sport:19': 'icon-Snooker',
  'vf:sport:1': 'icon-virtual',
  'vti:sport:5': 'icon-virtual',
  'sr:sport:137': [require('base/icons/png/e-soccer.png'), require('base/icons/png/e-soccer-act.png')],
  'sr:sport:153': 'icon-e-basketball',
  'sr:sport:195': 'icon-e-iceHockey',
  'sr:sport:31': 'icon-Badminton',
  'sr:sport:6': 'icon-Handball',
  'sr:sport:16': 'icon-AmericanFootball',
  'sr:sport:196': [eTennis, eTennisAct],
  'sr:sport:198': [eVolleyball, eVolleyballAct],
  'sr:sport:197': [eCricket, eCricketAct],
  esport: [require('base/icons/png/esport.png'), require('base/icons/png/esport-act.png')],
  'lv:sport:1': 'icon-vsoccer'
}

// 获取 sport icon / image, 优先使用 iconfont，其次用 image
const getSportIcon = (sportId = '') => sportIcon[sportId] || [defaultImageSrc, defaultImageSrc]

export default getSportIcon
